import React from 'react';
type MotifProps = {
  className?: string;
};

/**
 * Motivos de línea de la identidad DPS45 (trazo fino, heredan currentColor).
 * - BoardMotif: círculo abierto (el ciclo de experiencia) con su punto.
 *   Se mantiene el nombre para no romper imports de la estructura original.
 * - TwoChairs: dos sillas enfrentadas, una sólida y una punteada (silla vacía).
 */
export function BoardMotif({
  className
}: MotifProps) {
  return <svg viewBox="0 0 240 240" aria-hidden="true" className={className} data-id="element-22" data-mp="3gs0mrml0bvig">
      <circle cx="120" cy="120" r="100" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="560 68" transform="rotate(-58 120 120)" data-id="element-23" data-mp="3ljsbdrklrr5y" />
      <circle cx="120" cy="120" r="6" fill="currentColor" data-id="element-24" data-mp="3brmo2v5apxx3" />
    </svg>;
}
export function TwoChairs({
  className
}: MotifProps) {
  return <svg viewBox="0 0 240 150" aria-hidden="true" className={className} data-id="element-25" data-mp="32tkdbnvrfqwm">
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-26" data-mp="1oojyej1xcjl1">
        {/* Silla del cliente (sólida) */}
        <path d="M48 28 C46 60 46 82 50 98 L96 98 L96 132 M50 98 L50 132 M50 98 L52 106" data-id="element-27" data-mp="1jrtlg4lf243u" />
        <path d="M44 26 L52 26" data-id="element-28" data-mp="1xmvxl9guwpp3" />
        {/* Silla vacía (punteada) */}
        <path d="M192 28 C194 60 194 82 190 98 L144 98 L144 132 M190 98 L190 132" strokeDasharray="6 7" data-id="element-29" data-mp="1sqonr5lcau1v" />
        {/* Piso */}
        <path d="M20 136 L220 136" strokeWidth="2" opacity="0.5" data-id="element-30" data-mp="10ziwzfrie8p9" />
        {/* Círculo abierto entre ambas */}
        <path d="M108 70 A14 14 0 1 1 132 74" strokeWidth="2.5" data-id="element-31" data-mp="1eqno1tgt9snz" />
      </g>
    </svg>;
}